export default function length (x) {
  return x.length
}
